<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pzLhcB/tc-custom/9781611522495.jpg?1721057661774" alt="This image is the cover for the book Optimism Made Simple"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Optimism Made Simple
      </h1>
      <p class="bookDescription body article font2">
        <p>This is a short anthology of five true, inspirational stories which illustrate the amazing power of optimism.<br/><br/>Read about an airport shuttle driver who inexplicably waits past his midnight deadline for the author’s family. Find out what happens to a farmer who demands payment for hay he made but was given for free, or the stable manager who demands high payment from a rider to replace fence boards and posts the rider’s horses didn’t break. Meet a young man cured of Bell’s Palsy through prayer, or the unhappy woman who helps pay for a young relative’s college tuition after the author prays for her well-being.<br/><br/>Coupled with forgiveness and charitable thinking towards those who wish us evil, positive thoughts can resolve the toughest of situations to produce a happy result.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hilary Walker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d3214e6